module.exports = __webpack_public_path__ + "8763ffec863add83d3ed7a02faf3b114.pdf";